import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: () => import('./components/Home')
  },
  {
    path: '/about',
    component: () => import('./components/About')
  },
  {
    path: '/books',
    component: () => import('./components/Books')
  },
  {
    path: '/register',
    component: () => import('./components/Register')
  },
  {
    path: '/instructors',
    component: () => import('./components/Instructors')
  },
  {
    path: '/learning',
    component: () => import('./components/Learning')
  },
  {
    path: '/semesters',
    component: () => import('./components/Semesters')
  },
]

const router = new Router({routes})
router.afterEach(() => window.scroll(0, 0))


export default router
